export default "__VITE_ASSET__563cf102__"